import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import { DeliverySenderReceiverSection } from "./delivery-sender-receiver";
import {
  MultilingualText,
  renderMultilingualText
} from "../../../../../infrastructures/misc/js-pdf copy/render-multilingual-text";

export const DeliveryAddress = async (params: any, translate: Function) => {
  const leftMargin = params.startX + 5;
  params.doc.setTextColor("#333333");

  const {
    senderPositionY,
    recipientPositionY,
    recipientHeight,
    recipientRowText
  } = await DeliverySenderReceiverSection(params, translate);

  // ======================
  // PHONE + ADDRESS
  // ======================
  const product = params.data.sttProductType;

  let phoneRecipientPositionY = recipientPositionY + recipientHeight - 0.3;

  const phoneAndRecipientAddress = ellipsisString(
    params.data.sttRecipientPhone +
      " " +
      params.data.sttRecipientAddress.toUpperCase(),
    200 + params.data.sttRecipientPhone.length
  );

  await renderMultilingualText(
    new MultilingualText({
      doc: params.doc,
      text: phoneAndRecipientAddress,
      product,
      startX: leftMargin,
      startY: phoneRecipientPositionY,
      maxWidth: 70,
      fontSize: 6,
      fontStyle: "bold"
    })
  );

  if (recipientRowText > 3) {
    phoneRecipientPositionY += 1.5;
  }

  return {
    phoneRecipientPositionY,
    senderPositionY
  };
};
